// Function to create and manage overlay
function createOverlay(image) {
  const overlay = document.createElement('div');
  const imageUrl = image.getAttribute('src');
  
  overlay.setAttribute('class', 'image-magnify-full-size');
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.backgroundImage = `url('${imageUrl}')`;
  overlay.style.backgroundColor = 'var(--gradient-background)';
  overlay.style.position = 'absolute';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.zIndex = '10'; // Image ke upar dikhne ke liye
  overlay.style.backgroundRepeat = 'no-repeat';

  return overlay;
}

function moveWithHover(image, event, zoomRatio, overlay) {
  const container = event.target.getBoundingClientRect();
  
  // Mouse ki position container ke andar (0 to 1 ratio mein)
  const x = (event.clientX - container.left) / container.width;
  const y = (event.clientY - container.top) / container.height;

  // Background position ko percentage mein set karein (exact precision ke liye)
  const xPercent = x * 100;
  const yPercent = y * 100;

  overlay.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px auto`;
}

function enableZoomOnHover(zoomRatio = 2) {
  // Dawn theme images par target karein
  const images = document.querySelectorAll('.image-magnify-hover');

  images.forEach((image) => {
    // Click ya Hover event handling
    image.addEventListener('mouseenter', (event) => {
      const overlay = createOverlay(image);
      image.parentElement.appendChild(overlay);

      overlay.onmousemove = (e) => moveWithHover(image, e, zoomRatio, overlay);
      
      overlay.onmouseleave = () => {
        overlay.remove();
      };
    });
  });
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  enableZoomOnHover(2.5); // Zoom level yahan set karein
});